import { AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { IOpsPortalMonetaScheduleHistory } from '@schemas/opsPortal/types/monetaScheduleHistory';
import { QueryKeys } from '@utils/constants';
import { Endpoints } from '@utils/enums';
import { fetchDataFromEndpoint } from '@utils/fetchDataFromEndpoint/fetchDataFromEndpoint';

interface IUseGetContractPaymentScheduleHistoryQuery {
  enabled: boolean;
  uuid?: string;
}

export const useGetContractPaymentScheduleHistoryQuery = ({
  uuid,
  enabled = !!uuid,
}: IUseGetContractPaymentScheduleHistoryQuery) => {
  const {
    data: scheduleHistoryData,
    error: scheduleHistoryError,
    isLoading: isScheduleHistoryLoading,
  } = useQuery<IOpsPortalMonetaScheduleHistory, AxiosError>(
    [QueryKeys.SCHEDULE_HISTORY, uuid],
    () =>
      fetchDataFromEndpoint(`${Endpoints.FetchMonetaScheduleHistory}/${uuid}`),
    { enabled },
  );

  return {
    scheduleHistoryData,
    scheduleHistoryError,
    isScheduleHistoryLoading,
  };
};
